/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import styled from "styled-components";

const DropDownContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  margin: ${(props) => (props.topLabel ? "30px 0px 0px 0px" : "0px")};
`;

const DropDownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const DropDownButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;

  padding: ${(props) => (props.topLabel ? ".5em" : props.phone ? "0.5em" : "1em 0em 0em .5em")};
  background-color: ${(props) => (props.hasError ? "rgba(255, 217, 218, .5)" : "#FFFFFF")};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  color: rgba(0, 0, 0, 0.7);
  font-size: 1em;
  min-height: 44px;
  transition: 0.2s ease;
  cursor: pointer;
  flex-wrap: wrap;

  border-style: solid;
  border-width: 1px;
  border-color: rgba(34, 36, 38, 0.15);

  border-top-left-radius: ${(props) => ((props.topElement && props.leftElement) || (props.singleElement && props.topElement) ? "4px" : props.rounded ? "4px" : "0px")};
  border-top-right-radius: ${(props) => ((props.topElement && props.rightElement) || (props.singleElement && props.topElement) ? "4px" : props.rounded ? "4px" : "0px")};
  border-bottom-left-radius: ${(props) => ((props.bottomElement && props.leftElement && !props.selected) || (props.singleElement && props.bottomElement && !props.selected) ? "4px" : props.rounded && !props.selected ? "4px" : "0px")};
  border-bottom-right-radius: ${(props) => ((props.bottomElement && props.rightElement && !props.selected) || (props.singleElement && props.bottomElement && !props.selected) ? "4px" : props.rounded && !props.selected ? "4px" : "0px")};

  border-top-width: ${(props) => (props.topElement || props.bottomElement ? "1px" : props.bottomElement ? "0px" : null)};
  border-right-width: ${(props) => (props.rightElement || props.singleElement ? "1px" : props.topElement || props.leftElement || props.rowElement ? "0px" : null)};
  border-left-width: ${(props) => (props.leftElement || props.singleElement ? "1px" : null)};
  border-bottom-width: ${(props) => (props.bottomElement ? "1px" : props.topElement || props.leftElement || props.rightElement || props.rowElement || props.singleElement ? "0px" : null)};

  &:focus {
    background-color: #fafafa;
  }

  &:hover {
    background-color: #fafafa;
  }

  @media (max-width: 600px) {
    border-top-left-radius: ${(props) => (props.topElement ? "4px" : "0px")};
    border-top-right-radius: ${(props) => (props.topElement ? "4px" : "0px")};
    border-bottom-left-radius: ${(props) => (props.bottomElement ? "4px" : "0px")};
    border-bottom-right-radius: ${(props) => (props.bottomElement ? "4px" : "0px")};

    border-width: ${(props) => (props.topElement ? "1px 1px 0px 1px" : props.rowElement ? "1px 1px 0px 1px" : props.bottomElement ? "1px" : null)};
  }
`;

const Label = styled.div`
  font-size: ${(props) => (props.topLabel ? "1em" : ".8em")};
  position: absolute;
  top: ${(props) => (props.topLabel ? "-20px" : "2px")};
  left: ${(props) => (props.topLabel ? "0px" : "6px")};
  font-weight: ${(props) => (props.topLabel ? "700" : "400")};
  color: ${(props) => (props.topLabel ? "#9b9b9b" : "grey")};
  cursor: pointer;
  display: flex;
  z-index: 1;
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: calc(100% + 2px);
  min-width: auto;
  top: 0px;
  left: -1px;
  background-color: transparent;
  z-index: 100;
  max-height: 125px;
  overflow-y: auto;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
`;

const MenuItem = styled.div`
  background-color: ${(props) => (props.isFocused ? "#FAFAFA" : "white")};
  font-weight: ${(props) => (props.isFocused ? "bold" : "normal")};
  display: flex;
  min-height: 35px;
  align-items: center;
  padding: 5px 15px;
  transition: 0.2s ease;
  color: rgba(34, 36, 38, 0.75);
  cursor: pointer;
  zindex: 1000;

  border-style: solid;
  border-width: 1px;
  border-bottom-width: 0px;
  border-color: rgba(34, 36, 38, 0.15);

  border-width: ${(props) => (props.singleElement ? "1px" : null)};

  &:hover {
    background-color: #efefef;
  }
`;
const DropdownArrow = styled.i`
  position: absolute;
  top: 13px;
  right: 5px;
  color: rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;
const ErrorMessage = styled.span`
  font-style: italic;
  color: #fe5f55;
`;

const FadedText = styled.span`
  font-style: italic;
  color: grey;
  opacity: 0.7;
`;

const Anchor = styled.span`
  width: 100%;
  height: 0px;
  position: absolute;
  bottom: 0px;
  left: 0px;
`;

export { DropDownContainer, DropDownWrapper, DropDownButton, Label, MenuWrapper, MenuItem, DropdownArrow, ErrorMessage, FadedText, Anchor };
